module.exports = __webpack_public_path__ + "img/9.86019fe1.jpg";